import { BaseService } from 'core/services';
import PatientDetailRouteService from './PatientDetailRouteService';

class PatientDetailService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new PatientDetailRouteService());
    }
    
    async import(resource){
        const url = this.routeService.import(resource);
        const response = await this.apiClient.put(url, resource);
        return response.data || null;
    }

    async findStates(searchTerm){
        const url = this.routeService.findStates(searchTerm);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }
}

export default PatientDetailService;
